// extracted by mini-css-extract-plugin
export default {"formHeading":"wO-z","form":"xO-z","submitBtn":"yO-z","disabled":"zO-z","input":"AO-z","error":"BO-z","submitMsg":"CO-z","signIn":"DO-z"};